/* Fashion-only quick product type navigation. A selected pill is a toggle.
   Preserve Shopify market path, active sort and any other facet URL params. */
(() => {
  if (window.__kurlectiveFashionQuickTypesReady) return;
  window.__kurlectiveFashionQuickTypesReady = true;
  const param = 'filter.p.product_type';
  function nextUrl(value) {
    const url = new URL(window.location.href);
    const current = url.searchParams.get(param);
    url.searchParams.delete(param);
    if (current !== value) url.searchParams.set(param, value);
    url.searchParams.delete('page');
    return url;
  }
  function sync() {
    const active = new URL(window.location.href).searchParams.get(param);
    document.querySelectorAll('.k-fashion-quick-types__pill[data-quick-type]').forEach(pill => {
      const name = pill.dataset.quickType;
      if (!name) return;
      const selected = active === name;
      pill.classList.toggle('is-active', selected);
      if (selected) pill.setAttribute('aria-current', 'true');
      else pill.removeAttribute('aria-current');
      pill.href = nextUrl(name).toString();
    });
  }
  document.addEventListener('click', e => {
    const pill = e.target.closest?.('.k-fashion-quick-types__pill[data-quick-type]');
    if (!pill || e.defaultPrevented || e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    window.location.assign(nextUrl(pill.dataset.quickType).toString());
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, {once:true});
  else sync();

  // Reveal the active controlled collection chip without moving the page.
  // The parent chip scrolls naturally alongside its child chips.
  function revealActiveCollection() {
    document.querySelectorAll('.k-fashion-quick-types').forEach(rail => {
      const selected = rail.querySelector('.k-fashion-quick-types__pill.is-active:not(.k-fashion-quick-types__pill--parent)');
      if (!selected) return;
      const bounds = rail.getBoundingClientRect();
      if (bounds.width === 0) return; // Hidden desktop/mobile duplicate
      const item = selected.getBoundingClientRect();
      const minX = bounds.left + 10;
      const maxX = bounds.right - 10;
      const delta = item.left < minX ? item.left - minX : (item.right > maxX ? item.right - maxX : 0);
      if (Math.abs(delta) < 2) return;
      const previousBehavior = rail.style.scrollBehavior;
      rail.style.scrollBehavior = 'auto';
      rail.scrollLeft += delta;
      rail.style.scrollBehavior = previousBehavior;
    });
  }
  const positionCollectionChips = () => requestAnimationFrame(revealActiveCollection);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', positionCollectionChips, {once:true});
  } else positionCollectionChips();
  window.addEventListener('pageshow', positionCollectionChips);
})();
